// PRD-17 §FR-1..4 — director access predicate.
//
// Single source of truth for "is this professor authorized to see the
// Panel de Dirección?". Used by the route guard, the sidebar, and the
// settings card so the gate cannot drift between surfaces.
//
// Today the gate is *display-only*: the predicate runs on the SPA. Real
// authorization will arrive with the future role-model ADR — at which
// point the allowlist gives way to a role check without changing call
// sites.

import type { ProfessorSettings } from "@/types"

export const DIRECTOR_ALLOWLIST = ["admin@platonica.io"] as const

interface DirectorCheckable {
  email: string
  // Optional because some call sites (Settings card) only have the email.
  settings?: ProfessorSettings | null
}

export function isDirector(professor: DirectorCheckable | null | undefined): boolean {
  if (!professor) return false
  return DIRECTOR_ALLOWLIST.includes(
    professor.email.toLowerCase() as (typeof DIRECTOR_ALLOWLIST)[number],
  )
}
